module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Ga-Hb-Ia 后背.844d28dd.png";